<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix">
                <div style="display: flex;align-items: center;">
                    <span @click="goBack" style="cursor:pointer">
                        <span class="top_title">销售单</span>
                    </span>
                    <span>
                        <i class="iconfont" style="color: #333940;font-size: 18px;">&#xe605;</i>
                        <span class="top_title">销售详细</span>
                    </span>
                </div>
            </div>
            <div>
                <div class="searchItem">   
                    <div class="search">
                        <span class="searchtips">发货时间:</span>
                        <el-date-picker
                            v-model="searchDate.dateRan"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 230px"
                            :editable="false"
                            value-format="yyyy-MM-dd HH:mm"
                        >
                        </el-date-picker>
                    </div>
                    <div class="search">
                        <span class="searchtips">发货人:</span>
                        <el-input
                            v-model="searchDate.saler"
                            placeholder="请输入销售员名称"
                            style="width: 160px"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">商品名称:</span>
                        <el-input
                            v-model="searchDate.name"
                            placeholder="请输入商品名称"
                            style="width: 160px"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">订单号:</span>
                        <el-input
                            v-model="searchDate.onumber"
                            placeholder="请输入订单号"
                            style="width: 160px"
                        />
                    </div>
                    <div style="padding-right:10px">
                        <Customer :orderForm="searchDate" :hideStar='true'></Customer>
                    </div>
                    <div class="search">
                        <span class="searchtips">规格:</span>
                        <el-input
                            v-model="searchDate.pspec"
                            clearable
                            style="width: 160px"
                            placeholder="请输入规格"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">颜色:</span>
                        <el-input
                            v-model="searchDate.color"
                            clearable
                            style="width: 160px"
                            placeholder="请输入颜色"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">尺寸:</span>
                        <el-input
                            v-model="searchDate.size"
                            clearable
                            style="width: 160px"
                            placeholder="请输入尺寸"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">备注:</span>
                        <el-input
                            v-model="searchDate.remark"
                            clearable
                            style="width: 160px"
                            placeholder="请输入备注信息"
                        />
                    </div>
                    <div class="search">
                        <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
                    </div>
                </div>
                <div>
                    <el-button @click="colsDialog = !colsDialog" style="height:40px">
                        列设置
                    </el-button>
                </div>
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    style="
                        width: 100%;
                        margin-top: 20px;
                        margin-bottom: 20px;
                    "
                    border
                >
                    <el-table-column label="操作" align='center' width="180">
                        <template  slot-scope="props">
                            <el-button type="text" v-if="$common.hasLimits('orderSendDetailEdit')" @click="actionChange(props.row,true)">更改</el-button>
                            <el-button type="text" v-if="$common.hasLimits('orderRevoke')" @click="actionChange(props.row,false)">退货</el-button>
                            <el-button type="text" v-if="$common.hasLimits('orderSendDetailCancel')" @click="delOne(props.row)">取消</el-button>
                        </template>
                    </el-table-column>
                    <template v-for="(col, index) in cols">
                        <template v-if="col.show">
                            <el-table-column v-if="col.prop=='remark'" show-overflow-tooltip :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align">
                                <template slot-scope="scope">
                                    <div class="uni_ellipsis">{{ scope.row.remark }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column v-else :key="index" :prop="col.prop" :label="col.label" :min-width="col.min_width" :align="col.align">
                                <template #header v-if="col.column">
                                    {{col.label}}
                                    <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                                    <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                                    <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                                    <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                                </template>
                            </el-table-column>
                        </template>
                    </template>
                </el-table>
                <el-pagination
                    style="text-align: right"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 120, 250]"
                    :page-size="cp_pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :pager-count="5"
                >
                </el-pagination>
            </div>
        </el-card>
        <el-dialog :visible.sync="colsDialog" title="列设置" width="60%">
			<column-edit :cols="cols" />
			<div slot="footer" class="dialog-footer" v-if="$global.userType==0">
                <el-button type="text" @click="cols = initCols();" style="float:left">恢复默认设置</el-button>
				<el-button type="primary" @click="saveCols">保存</el-button>
			</div>
		</el-dialog>
        <el-dialog :title="editMode?'更改':'退货'" :visible.sync="ReturnDialog" width="60%">
            <div>
            <span style="padding-right:10px" v-if="$global.buyType!=2">{{$global.pack}}数:</span>
            <el-input v-model.number="count" @input="updateNum()" style="width:180px" v-if="$global.buyType!=2"></el-input>
            <span  style="padding:0 10px" v-if="$global.buyType!=1">{{$global.unit}}数:</span>
            <el-input v-model.number="num" @input="updateNum()" style="width:180px" v-if="$global.buyType!=1"></el-input>
            <span  style="padding:0 10px" v-if="sendInfo.wid>0&&$common.hasLimits('stockInfo')&&editMode">仓库:</span>
            <el-select v-model="wid" style="width:180px" v-if="sendInfo.wid>0&&$common.hasLimits('stockInfo')&&editMode">
                <el-option v-for="item in stockList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-input v-model="wid" @input="updateNum()" style="width:180px" v-if="$global.buyType!=1"></el-input>
            </div>
            <div class="rootbtn">
                <el-button type="primary" @click="saveSend()">确认</el-button>
                <el-button @click="ReturnDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Customer from '@/components/customer.vue';
import ColumnEdit from '@/components/table-column/Column.vue';
export default {
    components: { Customer,ColumnEdit },
    data() {
        return {
            loading:false,
            ReturnDialog: false,
            searchDate: {
                dateRan: "",
                cname:"",
                name: "",
                saler:"",
                cid:"",
                remark:"",
                onumber:"",
                column:'',
                order:'',
                pspec:'',
                color:'',
                size:'',
            },
            stockList:[],
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            currentPage: 1,
            cp_pagesize: 20,
            total: 100,
            tableData: [],
            sendInfo:{},
            searchObj:{},
            count:0,
            num:0,
            wid:'',
            maxnum:0,
            editMode:false,
            colsDialog:false,
            cols:[],
        };
    },
    created() {
        if(this.$route.query.cid){
            this.searchDate.cid = this.$route.query.cid;
            this.searchDate.cname = this.$route.query.customer;
            this.searchDate.dateRan = [this.$route.query.time,this.$route.query.time];
        }
        this.searchOrder();
        if(this.$global.userType==0){
            this.$api.getTableCols({tableName: 'ipad_sendDetail'}).then(res=>{
                if(res.data.code==1){
                    let obj = res.data.data;
                    if(obj.cols){
                        this.cols = obj.cols;
                    }else{
                        this.cols = this.initCols();
                    }
                }else{
                    this.cols = this.initCols();
                }
            })
        }else if(this.$global.userType==1){
            this.cols = this.initCols();
        }
        this.$api.listWareHouse().then((res)=>{
            if(res.data.code==1){
                res.data.data.forEach(e=>{
                    this.stockList.push(e);
                });
            }
        })
    },
    methods: {
        initCols(){
            let arr = [{
                prop: 'sdate',
                label: '发货时间',
                min_width: 180,
                show: true,
                align:'left',
                column:'sdate',
            },{
                prop: 'customer',
                label: '客户',
                min_width: 180,
                show: true,
                align:'left',
            },{
                prop: 'onumber',
                label: '订单号',
                min_width: 180,
                show: true,
                align:'left',
                column:'number',
            },{
                prop: 'name',
                label: '商品',
                min_width: 180,
                show: true,
                align:'left',
            },{
                prop: 'sendDesc',
                label: '发货总数',
                min_width: 100,
                show: true,
                align:'left',
            },{
                prop: 'cancelDesc',
                label: '退货数',
                min_width: 100,
                show: true,
                align:'left',
            },{
                prop: 'cerator',
                label: '发货人',
                min_width: 160,
                show: true,
                align:'left',
            },{
                prop: 'price',
                label: '单价(元)',
                min_width: 100,
                show: true,
                align:'left',
            },{
                prop: 'sumPrice',
                label: '金额(元)',
                min_width: 100,
                show: true,
                align:'left',
            },{
                prop: 'remark',
                label: '备注',
                min_width: 180,
                show: true,
                align:'left',
            },]
            return arr;
        },
        saveCols(){
            let obj = {
                tableName:'ipad_sendDetail',
                data:JSON.stringify(this.cols),
            }
            this.$api.setTableCols(obj).then(res=>{
                if(res.data.code==1){
                    this.$notify({
                        title: "列设置",
                        message: "修改成功",
                        type: "success",
                        duration: 2000,
                    });
                }
            })
            this.colsDialog = false;
        },
        searchOrder(){
            this.searchObj = {
                page: 1,
                limit: this.cp_pagesize,
            }
            this.currentPage = 1;
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.searchObj.start = this.searchDate.dateRan[0];
                this.searchObj.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.name){
                this.searchObj.pname = this.searchDate.name;
            }
            if(this.searchDate.saler){
                this.searchObj.saler = this.searchDate.saler;
            }
            if(this.searchDate.cid>0){
                this.searchObj.cid = this.searchDate.cid;
            }
            if(this.searchDate.remark){
                this.searchObj.remark = this.searchDate.remark;
            }
            if(this.searchDate.onumber){
                this.searchObj.onumber = this.searchDate.onumber;
            }
            if(this.searchDate.pspec){
                this.searchObj.pspec = this.searchDate.pspec;
            }
            if(this.searchDate.color){
                this.searchObj.color = this.searchDate.color;
            }
            if(this.searchDate.size){
                this.searchObj.size = this.searchDate.size;
            }
            this.sortTime();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.searchObj.column = this.searchDate.column;
                this.searchObj.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.searchObj.column;
                delete this.searchObj.order;
            }
            this.getListSend();
        },
        handleSizeChange(val) {
            this.cp_pagesize = val;
            this.searchOrder();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchObj.page = val;
            this.getListSend();
        },
        getListSend(checkend) {
            this.loading = true;
            this.$api.listSendDetail(this.searchObj).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = [];
                    let info = res.data.data;
                    this.total = info.count;
                    info.data.forEach((e) => {
                        let spec = "";
                        if(e.color){
                            spec = "-"+e.color+"-"+e.size;
                        }
                        e.totalnum = e.unit+e.notSendUnit;
                        let obj = {
                            id:e.id,
                            sdate: e.sdate,
                            customer: e.customer.name,
                            onumber:e.onumber,
                            name:e.pnumber+"-"+e.pname+spec,
                            number:e.totalnum,
                            sendUnit:e.unit,
                            cancelUnit:e.cancelUnit,
                            sendDesc:this.$common.changeNumDesc(e),
                            cancelDesc:this.$common.changeSendDesc(e.cancelUnit,e.punit),
                            cerator: e.creator,
                            price:e.price,
                            sumPrice:e.sumPrice,
                            remark: e.remark,
                            punit:e.punit,
                            wid:e.wid,
                            wname:e.wname,
                        };
                        this.tableData.push(obj);
                    });
                    this.loading = false;
                    if(checkend==true&&this.tableData.length==0){
                        this.goBack();
                    }
                }
            });
        },

        actionChange(order,edit){
            this.editMode = edit?true:false;
            if(edit){
                this.maxnum = order.number;
                this.count = Math.floor(order.sendUnit/order.punit);
                this.num = order.sendUnit - this.count*order.punit;
                this.wid = order.wid>0?order.wid:"";
            }else{
                this.maxnum = order.sendUnit;
                this.count = Math.floor(order.cancelUnit/order.punit);
                this.num = order.cancelUnit - this.count*order.punit;
            }
            this.sendInfo = order;
            this.ReturnDialog = true;
        },
        goBack(){
            this.$router.push("/send");
        },
        updateNum(){
            var c = parseInt(this.count);
            if(!c){
                c = 0;
            }
            this.count = c;
            var n = parseInt(this.num);
            if(!n){
                n = 0;
            }
            this.num = n;
            if(this.count*this.sendInfo.punit+this.num>this.maxnum){
                if(this.$global.buyType==2){
                    this.count = 0;
                    this.num = this.maxnum;
                }else{
                    this.count = Math.floor(this.maxnum/this.sendInfo.punit);
                    this.num = this.maxnum - this.count*this.sendInfo.punit;
                }
            }
        },
        saveSend(){
            let val = this.count*this.sendInfo.punit+this.num;
            if(this.editMode){
                let obj = {
                    sdiid:this.sendInfo.id,
                    sendedUnit:val,
                }
                if(this.sendInfo.wid>0){
                    obj.wid=this.wid;
                }
				this.$api.editSendDetail(obj).then(res=>{
					if(res.data.code==1){
                        this.$notify({
                            title: "销售详细",
                            message: "修改成功",
                            type: "success",
                            duration: 1000,
                            onClose:()=>{
                                this.getListSend();
                            }
                        });
					}else{
						this.$common.error(res.msg);
                    }
                    this.ReturnDialog = false;
				})
			}else{
				this.$api.cancelSendItemUnit({sdiid:this.sendInfo.id,cancelUnit:val}).then(res=>{
					if(res.data.code==1){
                        this.$notify({
                            title: "销售详细",
                            message: "修改成功",
                            type: "success",
                            duration: 1000,
                            onClose:()=>{
                                this.getListSend();
                            }
                        });
					}else{
						this.$common.error(res.msg);
                    }
                    this.ReturnDialog = false;
				})
			}
        },
        delOne(sidata){
            let temp = {
				data:'',
				inRecord:0,
				remark:'',
			}
			let dd = [];
			let obj = {
				id:sidata.id,
				returnAmount:sidata.sendUnit,
				wid:'',
			}
			dd.push(obj);
			temp.data = JSON.stringify(dd);
			this.$api.cancelOrderDetailSend(temp).then(res=>{
				if(res.data.code==1){
                    this.$common.success('取消成功');
                    if((this.searchObj.page-1)*(this.searchObj.limit)>=(this.total-1)){
                        this.currentPage = 1;
                        this.searchObj.page = 1;
                    }
                    this.getListSend(true);
				}else{
					this.$common.error(res.msg);
				}
			})
        }
    },
};
</script>